import request from '@/request'

// 个人排行榜
export const personRank = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/personRank.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 个人助力值增长明细
export const personIntegral = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/personIntegral.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 个人首页
export const personBasic = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/personBasic.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 判断是否首次完成任务
export const firstTaskPanduan = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/firstTaskPanduan.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 创建队伍
export const addTeam = (data) => {
  return request({
    url: '/exterior_intFtuLlsTeaminfo/addTeam.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 修改队伍名字
export const updateTeamName = (data) => {
  return request({
    url: '/exterior_intFtuLlsTeaminfo/updateTeamName.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 进入队伍
export const joinTeam = (data) => {
  return request({
    url: '/exterior_intFtuLlsTeaminfo/joinTeam.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 团队信息
export const teamBasic = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/teamBasic.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 团队排行榜
export const teamStatistic = (data) => {
  return request({
    url: '/exterior_intFtuLlsIntegralinfo/teamStatistic.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 首次进入
export const firstJoin = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/firstJoin.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 邀请好友
export const addInvite = (data) => {
  return request({
    url: '/exterior_intFtuLlsinviteinfo/addInvite.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 邀请好友任务新增
export const addTaskThird = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/addTaskThird.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 领取首次任务助力值
export const firstTaskGet = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/firstTaskGet.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 领取首次填写地址助力值
export const firstAddressGet = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/firstAddressGet.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 首次填写地址任务新增
export const firstAddressTaskAdd = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/firstAddressTaskAdd.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 每日答题任务新增
export const addTaskOne = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/addTaskOne.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 周六挑战答题任务新增
export const addTaskSecond = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/addTaskSecond.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 额外助力值领取
export const everyDayFirst = (data) => {
  return request({
    url: '/exterior_intFtuLlsIntegralinfo/everyDayFirst.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 时间判断
export const endPanduan = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/endPanduan.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 问卷详情
export const getExaminfo = (data) => {
  return request({
    url: '/mobile_extExaminfo/getExaminfo.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 今日邀请数
export const inviteTimes = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/inviteTimes.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 汇总信息
export const getView = (data) => {
  return request({
    url: '/exterior_intFtuLlsOperate/getView.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 红船配置信息
export const viewall = (data) => {
  return request({
    url: '/exterior_intFtuLlsTaskinfo/view.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 判断领取
export const personAcount = (data) => {
  return request({
    url: 'exterior_intFtuLlsTaskinfo/personAcount.action',
    method: 'post',
    data,
    isMd5: false
  })
}
